var path = 'areas/library/feeds/views/create.html';
var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href=\"#/library/feeds\">External Feeds</a></li>\r\n    <li><a href=\"#/library/feeds/new\">Create New</a></li> </script> <div class=\"form-box form-horizontal\"> <h3>{{ pageTitle }}</h3> <feed-editor></feed-editor> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/library/feeds/views/create.html
// module id = 7727940565306987
// module chunks = 1